import React from "react";
import OutlineTextInput from "../input/OutlineTextInput";
import { useDispatch, useSelector } from "react-redux";
import styles from "./Debitcard.module.scss";
import Button from "../button/Button";
import { apiClient } from "../../hooks/apiClient";
import {
  openLoader,
  closeLoader,
} from "../../redux/actions/loader/loaderActions";
import { openToastAndSetContent } from "../../redux/actions/toast/toastActions";
import {
  // ToastSuccessStyles,
  ToastErrorStyles,
} from "../../constants/toastStyles";
import { ReactComponent as VisaCardIcon } from "../../assets/images/card-brand-logos/visa.svg";
import { ReactComponent as MasterCardIcon } from "../../assets/images/card-brand-logos/mastercard.svg";
import { ReactComponent as VerveCardIcon } from "../../assets/images/card-brand-logos/verve.svg";
import { ReactComponent as SuccessIcon } from "../../assets/images/check-circle.svg";
import { usePaymentInputs } from "react-payment-inputs";
// import { useSelector } from "react-redux";
import encryptForge from "../../utils/encryptForge";
import { commarize } from "../../utils/helpers";
import { Post } from "../../api/client";
import PrimaryTextInput from "../input/PrimaryTextInput";
import Label from "../Label/Label";
import { creditCardType } from "../../utils/cardType";
import { handleCardDisplay, is_numeric } from "../../utils/cardDisplay";
import { CheckBoxOutlineBlankRounded } from "@material-ui/icons";
import { CheckBoxOutlineBlankSharp } from "@mui/icons-material";
import {
  TrackOrderStatusAction,
  payOrderAction,
} from "../../redux/actions/orderStatus/orderStatusAction";
import PendingPaymentCard from "../PendingPaymentCard/PendingPaymentCard";
import SuccessfulPaymentCard from "../SuccessfulPaymentCard/SuccessfulPaymentCard";

type DebitCardProps = {
  reference: string;
  currency: string;
  amount: number;
  saveCards: any[]
};
const DebitCard = ({ reference, amount, currency, saveCards }: DebitCardProps) => {
  interface initTypes {
    CardNumber: string;
    MonthAndYear: string;
    Cvv: string;
    expiryDate: string;
    pin: string;
    saveCard: string;
    savedCardId?: number;
  }

  const initProps: initTypes = {
    CardNumber: "",
    MonthAndYear: "",
    Cvv: "",
    expiryDate: "",
    pin: "",
    saveCard: "false",
  };


  const dispatch = useDispatch();
  const handleFormBlur = () => {
    // dispatch(updateIndividualForm({ ...inputs }));
  };
  const orderfee = useSelector((state) => state.orderFeeReducer);
  const fee: number = orderfee?.data?.customerFee ?? 0;

  const [inputs, setInputs] = React.useState(initProps);
  const [useSavedCards, setUseSavedCards] = React.useState(false);
  const [paymentUrl, setPaymentUrl] = React.useState("");
  // const [success, setSuccess] = React.useState(false);
  const { /*meta, getCardNumberProps,getCVCProps ,*/ getExpiryDateProps } =
    usePaymentInputs();
  const [expiryDate, setExpiryDate] = React.useState<any>();
  // const [encryptedOrder, setEncryptedOrder] = React.useState<any>("");
  // const [closeWindow, setCloseWindow] = React.useState(false);
  // const [redirectUrl, setRedirectUrl] = React.useState("");
  const [activeSection, setActiveSection] = React.useState(
    "collect-card-details"
    // "confirm-redirect"
  );
  // const [intervalholder, setIntervalHolder] = React.useState<any>(null);
  // const { orderDetails } = useSelector((state) => state.orderDetailsReducer);
  // const orderReference = orderDetails.data?.order?.reference;

  let myWindow: any;

  function openWin(redirectUrl: string) {
    myWindow = window.open(redirectUrl, "_blank");
    if (myWindow) {
      myWindow.focus();
    } else {
      dispatch(
        openToastAndSetContent({
          toastStyles: ToastErrorStyles,
          toastContent: "The redirect to the payment page was blocked by your browser, please enable the redirect to complete payment",
        })
      );
    }
  }

  // window?.top?.postMessage('I am Iframe', '*')
  // if (redirectUrl && closeWindow === false) {
  //   openWin();
  // } else if (redirectUrl && closeWindow === true) {
  //   closeWin();
  // }
  function closeWin() {
    myWindow?.close();
  }

  // if (closeWindow === false) {
  //   openWin();
  // }

  // setInterval(closeWin, closeWindow && !!closeWindow ? 20000 : 20000);

  // window.open(redirectUrl, "_blank").close();

  const payload: any = {
    reference: reference,
    paymentOption: "C",
    card: {
      cardNumber: inputs.CardNumber.replaceAll(" ", ""),
      cvv: inputs.Cvv,
      pin: inputs.pin,
      expiryMonth: inputs.expiryDate?.substring(0, 2),
      expiryYear: inputs.expiryDate?.slice(-2),
      saveCard: inputs.saveCard == "true",
      savedCardId: null
    },
  };

  const continuePayment = () => {
    setActiveSection("confirm-payment");
    openWin(paymentUrl)
    TrackOrderStatusAction(
      payload,
      dispatch,
      (cbdata: any) => {
        if (cbdata?.status == "completed") {
          setActiveSection("successful");
        } else {
          setActiveSection("confirm-payment-pending");
        }
      },
      myWindow
    );
  }
  const payOrder = async (payload: any) => {
    try {
      payOrderAction(payload, dispatch, (data: any) => {
        const status = data?.data?.orderPayment?.orderPaymentResponseCode;
        const redirect_url = data?.data?.paymentDetail?.redirectUrl;
        setActiveSection("confirm-redirect");
        if (status != "00" && redirect_url) setPaymentUrl(redirect_url)
      });
    } catch (error: any) {
      dispatch(closeLoader());
      const message =
        error?.response?.data?.Message || error?.response?.data?.message;
      dispatch(
        openToastAndSetContent({
          toastStyles: ToastErrorStyles,
          toastContent: message,
        })
      );
    }
  };
  const debitCardTransaction = async () => {
    try {
      sessionStorage.setItem("checkout-payment-completed", "false");
      payOrder(payload);
    } catch (error: any) {
      dispatch(closeLoader());
      const message =
        error?.response?.data?.Message || error?.response?.data?.message;
      dispatch(
        openToastAndSetContent({
          toastStyles: ToastErrorStyles,
          toastContent: message,
        })
      );
    }
  };

  const handleSubmit = (e: React.SyntheticEvent) => {
    if (paymentUrl) return continuePayment()
    e.preventDefault();
    dispatch(openLoader());
    debitCardTransaction();
  };

  const SubmitSavedCard = (savedCardId: number) => {
    dispatch(openLoader());
    payload.card.savedCardId = savedCardId;
    debitCardTransaction();
  };
  const disabledFunction = () => {
    if (!inputs.CardNumber || !inputs.expiryDate || !inputs.Cvv) return true;
  };

  const updateProps = (event: React.ChangeEvent<HTMLInputElement>) => {
    let newValue = event.target.value;
    const inputName = event.target.name;
    if (inputName == "expiryDate") {
      console.log({ newValue })
      if (newValue.length != 3 && !is_numeric(newValue)) {
        if (newValue.length < 3) return;
        const lastdigit = newValue.split("/")[1];
        console.log({ lastdigit })
        if (!is_numeric(lastdigit)) return;
      }
      if (newValue.length == 2 && inputs.expiryDate.length < newValue.length) {
        if (!is_numeric(newValue)) return;
        newValue += "/";
      } else if (newValue.length >= 5) {
        const cvvinput = document.getElementById("cvv");
        if (cvvinput) {
          cvvinput.focus();
        }
      }
    }
    if (inputName == "CardNumber") {
      if (newValue.length >= 16) {
        const expiryinput = document.getElementById("inputexpiry");
        if (expiryinput) {
          expiryinput.focus();
        }
      }
    }

    if (inputName == "saveCard") {
      newValue = inputs.saveCard == "false" ? "true" : "false"
    }

    if (inputName.toLowerCase() == "cvv") {
      if (newValue && !is_numeric(newValue)) return;
      if (newValue?.length > 3) return;
    }

    console.log(inputName, newValue, inputs)
    setInputs((prevState: initTypes) => {
      return {
        ...prevState,
        [inputName]: newValue,
      };
    });
  };

  const handleChangeExpiryDate = (event: any) => {
    setExpiryDate(event.target.value);
  };

  const getCardTypeImage = (cardumber: string, cardtype?: string) => {
    if (!cardtype) cardtype = creditCardType(cardumber);
    switch (cardtype) {
      case "MASTERCARD":
        return <MasterCardIcon />;
      case "VISA":
        return <VisaCardIcon />;
      case "VERVE":
        return <VerveCardIcon />;
      default:
        return <></>;
    }
  };

  const getPayButtonText = () => {
    if (paymentUrl) return `Continue your payment`
    return `Pay ${currency} ${commarize(amount + fee)}`
  }

  const CollectCardDetails = (
    <div className={styles.businessForm}>
      <form
        onBlur={handleFormBlur}
        onSubmit={handleSubmit}
        className={styles.formWidth}
      >
        {!useSavedCards && <>
          <div>
            {/* <Label value="Card Number" /> */}
            <div className={styles.cardNumberWrapper}>
              <PrimaryTextInput
                handleChange={updateProps}
                inputName="CardNumber"
                inputLabel=" Card Number"
                inputValue={handleCardDisplay(inputs.CardNumber)}
                style={{ width: "100%" }}
              />
              <span className={styles.cardBrandLogo}>
                {getCardTypeImage(inputs.CardNumber)}
              </span>
            </div>
          </div>
          {creditCardType(inputs.CardNumber) == "VERVE" && (
            <div>
              {/* <Label value="Card Pin" /> */}
              <div className={styles.cardNumberWrapper}>
                <PrimaryTextInput
                  handleChange={updateProps}
                  inputName="pin"
                  inputType="number"
                  inputLabel=" Card Pin"
                  inputValue={inputs.pin}
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          )}
          <div className={styles.cardDetails}>
            {/* <OutlineTextInput
            handleChange={updateProps}
            inputName="MonthAndYear"
            inputLabel="MM/YY"
            inputValue={inputs.MonthAndYear}
            style={{ width: "100%" }}
          /> */}
            <div>
              {/* <Label value="Expiry Date" />
            <br /> */}
              <PrimaryTextInput
                handleChange={updateProps}
                inputName="expiryDate"
                inputLabel="MM/YY"
                inputValue={inputs.expiryDate}
                style={{ width: "100%" }}
              />
              {/* <input
              {...getExpiryDateProps({ onChange: handleChangeExpiryDate })}
              value={expiryDate}
              handleChange={updateProps}
              name="expiryDate"
              id="inputexpiry"
              className={styles.expiryDate}
            /> */}
            </div>
            <div>
              {/* <Label value="CVV" />
            <br /> */}
              <PrimaryTextInput
                id="cvv"
                handleChange={updateProps}
                inputName="Cvv"
                inputLabel="CVV"
                inputType="password"
                inputValue={inputs.Cvv}
                style={{ width: "100%" }}
              />
            </div>
          </div>
          <div className={styles.rememberCard}>
            <input type="checkbox" name="saveCard" onInput={updateProps} />
            <span>Save my information for a faster checkout</span>
          </div>
          <Button
            value={getPayButtonText()}
            disabled={disabledFunction()}
            onClick={handleSubmit}
            className={disabledFunction() ? styles.button : styles.buttonActive}
          />
        </>}
        <p className={styles.PayWithSavedCardBtn} onClick={() => setUseSavedCards(!useSavedCards)}>{useSavedCards ? "Click here to enter new card details" : "Click here to pay with a saved card"}</p>
        {useSavedCards && (
          <div className={styles.PayWithSavedCardWrapper}>
            {[...saveCards].map(x => (
              <div className={styles.PayWithSavedCardItem} onClick={() => SubmitSavedCard(x.savedCardId)}>
                <span>
                  {getCardTypeImage("", x.cardType)}
                </span>
                <span>
                  {x.cardFirstSixDigits}xxxxxxxx{x.cardLastFourDigits}
                </span>
                <span>
                  {x.cardExpiryMonth}/{x.cardExpiryYear}
                </span>
              </div>
            ))}
          </div>
        )
        }
      </form>
    </div>
  );

  const ConfirmRedirect = (
    <div className={styles.confirmRedirect}>
      <p>
        You will be redirected to your card issuer’s verification page to
        complete this transaction
      </p>
      <Button
        value={getPayButtonText()}
        onClick={handleSubmit}
        className={styles.confirmRedirectButton}
      />
    </div>
  );

  const ConfirmingPayment = (
    <div className={styles.confirmRedirect}>
      <p>Checking transaction status... Please wait</p>
    </div>
  );

  const GetActiveSection = () => {
    switch (activeSection) {
      case "successful":
        return <SuccessfulPaymentCard paymentmethod="card" />;
      case "confirm-redirect":
        return ConfirmRedirect;
      case "confirm-payment":
        return ConfirmingPayment;
      case "confirm-payment-pending":
        return <PendingPaymentCard paymentmethod="card" />;
      case "collect-card-details":
      default:
        return CollectCardDetails;
    }
  };
  return GetActiveSection();
};

export default DebitCard;
